mutation signUpUSUser($input: SignUpUserInput!) {
  signUpUSUser(input: $input) {
    status
    errorCode
    message
  }
}
